var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8327 0L1.22021 19.6125C0.833354 19.9994 0.526484 20.4586 0.317121 20.9641C0.107758 21.4695 4.07615e-09 22.0112 0 22.5583C-4.07615e-09 23.1054 0.107758 23.6472 0.317121 24.1526C0.526484 24.6581 0.833354 25.1173 1.22021 25.5042C1.60706 25.891 2.06632 26.1979 2.57177 26.4073C3.07721 26.6166 3.61895 26.7244 4.16604 26.7244C4.71313 26.7244 5.25486 26.6166 5.76031 26.4073C6.26576 26.1979 6.72502 25.891 7.11187 25.5042L16.666 15.95V47.5583C16.666 48.6634 17.105 49.7232 17.8864 50.5046C18.6678 51.286 19.7276 51.725 20.8327 51.725C21.9378 51.725 22.9976 51.286 23.779 50.5046C24.5604 49.7232 24.9994 48.6634 24.9994 47.5583V15.95L34.5535 25.5042C34.9396 25.8924 35.3986 26.2006 35.9042 26.4108C36.4097 26.6211 36.9518 26.7293 37.4994 26.7293C38.0469 26.7293 38.589 26.6211 39.0946 26.4108C39.6001 26.2006 40.0592 25.8924 40.4452 25.5042C41.2263 24.7228 41.6651 23.6632 41.6651 22.5583C41.6651 21.4535 41.2263 20.3939 40.4452 19.6125L20.8327 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.99622f8da312df5eb9878aa3783dac0a.svg";
export { ForwardRef as ReactComponent };